"use client"

import { Button } from "@/components/ui/button"
import { Loader } from "lucide-react"

interface ImportSubscribersButtonProps {
  selectedFile: File | null
  importInProgress: boolean
  onClick: () => void
}

export function ImportSubscribersButton({
  selectedFile,
  importInProgress,
  onClick,
}: ImportSubscribersButtonProps) {
  return (
    <Button
      variant="outline"
      disabled={!selectedFile || importInProgress}
      onClick={onClick}
      className="w-fit"
    >
      {importInProgress && <Loader className="mr-2 h-4 w-4 animate-spin" />}
      Import
    </Button>
  )
}
